import React, { createContext, useContext, useReducer, useMemo, Dispatch } from 'react';
import useCombinedReducers from 'use-combined-reducers';
import packageReducer from '~shared/reducers/packageReducer';
import Grow2529Reducer, { grow2529State } from '~app/pages/Pricing/experiments/grow_2529_forms/reducer';
import Grow2792Reducer, { grow2792State } from '~app/pages/Pricing/experiments/grow_2792_pnp_refresh_v1/reducer';
import { combinedStates, packageState } from '~shared/state';

import { RootPricingProviderStateType, CombinedStates } from '~shared/types/pricing/state';
import { CombinedActions } from '~shared/types/pricing/actions';

export const PricingStateContext = createContext<{ state: CombinedStates; dispatch: Dispatch<CombinedActions> }>({
  state: combinedStates,
  dispatch: () => {},
});

export function PricingStateProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const [state, dispatch] = useCombinedReducers<CombinedStates, CombinedActions>({
    packages: useReducer(packageReducer, packageState),
    grow2529: useReducer(Grow2529Reducer, grow2529State),
    grow2792: useReducer(Grow2792Reducer, grow2792State),
  });

  const value = useMemo(() => {
    return { state, dispatch };
  }, [dispatch, state]);

  return <PricingStateContext.Provider value={value}>{children}</PricingStateContext.Provider>;
}

export const usePricingState = (): RootPricingProviderStateType => useContext(PricingStateContext);
